<template>
  <section>
    <sys-dialog v-show="dialogVisible" :bgi="dialogBgi" :show-close="true" :error-msg="errorMsg" @close="closeDialog" />
    <sys-loading :loading="loading" />
    <div :class="isMobile ? 'root' : 'container'">
      <div class="left" v-if="!isMobile">
        <img src="../assets/lottery/left.png" alt />
      </div>
      <div class="mid">
        <img class="logo" src="../assets/8day-logo.png" />
        <img class="title" src="../assets/lottery/title.png" />
        <div class="form">
          <div class="tag">
            <div class="tag-item login" :class="!isRegisterAction ? 'active' : ''" @click="switchTag('login')"></div>
            <div class="tag-item reg" :class="isRegisterAction ? 'active' : ''" @click="switchTag('reg')"></div>
          </div>
          <el-form :model="form" ref="form" :rules="rules">
            <el-form-item prop="userName">
              <div class="form-input">
                <img src="../assets/lottery/icon-user.png" />
                <input v-model="form.userName" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
              </div>
            </el-form-item>
            <el-form-item prop="phone" v-if="isRegisterAction">
              <div class="form-input">
                <img src="../assets/lottery/icon-phone.png" />
                <input v-model="form.phone" placeholder="Số điện thoại" maxlength="11" oninput="value=value.replace(/^\D/, '')" />
              </div>
            </el-form-item>
            <el-form-item prop="password">
              <div class="form-input" :style="!isRegisterAction ? { marginBottom: 0 } : ''">
                <img src="../assets/lottery/icon-password.png" />
                <input v-model="form.password" type="password" autocomplete="new-password" placeholder="Mật khẩu" />
              </div>
            </el-form-item>
            <el-form-item prop="email" v-if="isRegisterAction">
              <div class="form-input">
                <img src="../assets/lottery/icon-email.png" />
                <input v-model="form.email" autocomplete="off" placeholder="Email" />
              </div>
            </el-form-item>
            <el-form-item v-if="isRegisterAction">
              <div class="form-input" style="position: relative;">
                <input v-model="form.verificationCode" maxlength="4" autocomplete="off" />
                <div class="codeImg">
                  <span @click="getVerify" v-if="codeImg" class="validateCode">
                    <img class="img" :src="codeImg" alt="code" />
                  </span>
                </div>
              </div>
            </el-form-item>
          </el-form>
          <a v-if="!isRegisterAction" href="https://www.8day.com">Quên mật khẩu ?</a>
          <v-captcha ref="vcaptcha1" :dialogVisible="dialogVisible" :showCheck="showCheck" :vstyle="
              isMobile
                ? {
                    width: '70%',
                    height: '20vw',
                    bottom: '-8vw',
                    position: 'absolute',
                    'z-index': 999
                  }
                : {
                    width: '340px',
                    height: '100px',
                    bottom: '-40px',
                    position: 'absolute',
                    'z-index': 999
                  }
            " :nativeButton="
              isMobile
                ? {
                    width: '100%',
                    height: '20vw'
                  }
                : {
                    width: '100%',
                    height: '100px'
                  }
            " @cb="register">
            <div v-show="isRegisterAction" class="btn" @click="submitAction(1)">
              ĐĂNG KÝ +80K
            </div>
          </v-captcha>
          <div v-show="!isRegisterAction" class="btn" @click="submitAction(2)">
            ĐĂNG NHẬP
          </div>
        </div>
        <div class="cts">
          <a :href="contacts.facebook" target="_blank">
            <img src="../assets/icon-fb.png" />
          </a>
          <a :href="contacts.telegram" target="_blank">
            <img src="../assets/icon-tg.png" />
          </a>
        </div>
      </div>
      <div class="right" v-if="!isMobile">
        <img src="../assets/lottery/right.png" alt />
      </div>
    </div>
  </section>
</template>

<script>
import md5 from "js-md5";
import {
  FORM_VALID_MESSAGE,
  DOMAIN_AGENT_CODE,
  CONTRACTS,
  PHONES_PREFIX_FORE,
  PHONES_PREFIX_REPLACE
} from "../utils/constant";
import { userRegister, userLogin, createCustomer, getCode } from "../utils/request";
import {
  encodePlatformUrl,
  validForm,
  isMobile,
  validatePhone,
  validateEmail
} from "../utils/tools";
import { BASE_URL } from "../utils/api";
import { captcha } from "@/mixins/captcha";

export default {
  name: "Sport",
  mixins: [captcha],
  data() {
    return {
      codeImg: '',
      isMobile: isMobile(),
      loading: false,
      isRegisterAction: true,
      dialogVisible: false,
      dialogBgi: require("../assets/lottery/bgi-dialog.png"),
      contacts: CONTRACTS,
      baseUrl: BASE_URL,
      form: {
        by: 1,
        username: "",
        verificationCode: "",
        userName: "",
        phone: "",
        password: "",
        email: "",
        link: "",
        domain: "",
        inviteCode: null
      },
      rules: {
        userName: [
          {
            required: true,
            trigger: "change",
            message: FORM_VALID_MESSAGE.emptyMsg
          },
          {
            min: 4,
            max: 20,
            trigger: "change",
            message: FORM_VALID_MESSAGE.usernameFormatErr
          }
        ],
        password: [
          {
            required: true,
            trigger: "change",
            message: FORM_VALID_MESSAGE.emptyMsg
          },
          {
            min: 6,
            max: 15,
            trigger: "change",
            message: FORM_VALID_MESSAGE.passwordMsg
          }
        ],
        phone: [
          {
            required: true,
            trigger: "change",
            message: FORM_VALID_MESSAGE.emptyMsg
          },
          { validator: validatePhone }
        ],
        email: [
          {
            required: true,
            trigger: "change",
            message: FORM_VALID_MESSAGE.emptyMsg
          },
          { validator: validateEmail }
        ]
      },
      errorMsg: {
        title: "",
        content: ""
      }
    };
  },
  mounted() {
    window.onresize = () => {
      this.isMobile = isMobile();
    };
    this.getVerify();
  },
  methods: {
    getVerify() {
      getCode({}).then(res => {
        this.codeImg = res.body.data
      })
    },
    switchTag(opt) {
      if (opt == "login") {
        this.isRegisterAction = false;
      } else {
        this.isRegisterAction = true;
      }
      this.$refs.form.resetFields();
    },
    submitAction(type) {
      let that = this;
      this.$refs.form.validate(valid => {
        if (valid) {
          that.loading = true;
          // 登陆
          if (type == 2) {
            let temp = Object.assign({}, that.form);
            let params = {
              acctType: 6,
              by: 1,
              email: temp.email,
              userName: temp.userName,
              phone: temp.phone,
              password: md5(temp.password)
            };
            that.login(params);
          } else {
            const inviteCode = DOMAIN_AGENT_CODE[location.host] || "";
            console.log("当前域名。。。", location.host, "code...");
            that.form.inviteCode = inviteCode;
            that.form.domain = location.host;
            that.form.username = that.form.userName;
            that.handleCheck(that.register);
          }
        }
      });
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.loggedTitle,
              FORM_VALID_MESSAGE.loggedMsg
            );
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      let params = (this.params = Object.assign({}, this.form));
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      params.phone = this.replacePhonePrefix(params.phone);
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerTitle,
              FORM_VALID_MESSAGE.registerMsg
            );
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.getVerify();
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.data.msg
            );
            this.handleOpen(res.data.code);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    },
    replacePhonePrefix(phone) {
      if (
        phone.length == 11 &&
        PHONES_PREFIX_FORE.includes(phone.substr(0, 4))
      ) {
        return `${PHONES_PREFIX_REPLACE[phone.substr(0, 4)]}${phone.substr(4)}`;
      } else {
        return phone;
      }
    }
  }
};
</script>

<style lang="less" scoped>
input::placeholder {
  color: #ffffff;
  font-size: 22px;
  font-style: normal;
  font-weight: normal;
}
-webkit-input::placeholder {
  color: #ffffff;
  font-size: 22px;
  font-style: normal;
  font-weight: normal;
}

/deep/ .el-form {
  width: 100%;

  .el-form-item {
    width: 100%;
    margin: 0;
  }

  .el-form-item__error {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    position: absolute;
    bottom: 8px;
    left: 13%;
    padding: 0;
    top: auto;
  }
}

.container,
.root {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  background-image: url("../assets/lottery/bgi-pc.jpg");
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .left,
  .right {
    width: 30%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    img {
      width: 400px;
    }
  }

  .right {
    justify-content: flex-start;
  }

  .mid {
    width: 40%;
    height: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    padding: 40px 0 10px;
    box-sizing: border-box;

    img.logo {
      width: 200px;
    }

    img.title {
      width: 85%;
    }

    .form {
      width: 67.7%;
      background-image: url("../assets/lottery/bgi-form.png");
      background-size: 100% 100%;
      display: flex;
      flex-flow: column;
      align-items: center;
      position: relative;
      padding: 0 10px 90px;
      box-sizing: border-box;
      margin: 20px 0 40px;

      .tag {
        width: 100%;
        display: flex;
        margin-bottom: 20px;

        .tag-item {
          cursor: pointer;
          height: 63px;

          &.reg {
            width: 40%;
            background-image: url("../assets/lottery/btn-reg.png");
            background-size: 100% 100%;

            &.active {
              width: 60%;
              background-image: url("../assets/lottery/btn-reg-active.png");
              background-size: 100% 100%;
            }
          }

          &.login {
            width: 40%;
            background-image: url("../assets/lottery/btn-login.png");
            background-size: 100% 100%;

            &.active {
              width: 60%;
              background-image: url("../assets/lottery/btn-login-active.png");
              background-size: 100% 100%;
            }
          }
        }
      }

      .form-input {
        width: 70%;
        margin: 0 auto 20px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 10px 20px;
        background-size: 100% 100%;
        transition: all 0.25s ease;
        border-radius: 20px;
        background-image: url("../assets/lottery/bgi-form-input.png");
        .codeImg {
          cursor: pointer;
          width: 150px;
          height: 100%;
          position: absolute;
          right: -16px;
          top: 1px;
          .img {
            width: 150px;
            height: 100%;
            padding: 8px 20px;
            box-sizing: border-box;
            border-radius: 0 23px 23px 0;
          }
        }

        img {
          margin-right: 10px;
        }

        input {
          border: none;
          outline-width: 0;
          background-color: transparent;
          height: 40px;
          width: 80%;
          font-family: UTMAvo;
          font-weight: 500;
          font-size: 25px;
          color: #fff;
          padding: 1px 2px;
        }
      }

      .btn {
        width: 340px;
        height: 100px;
        text-align: center;
        line-height: 85px;
        font-size: 32px;
        color: #ffffff;
        font-weight: bold;
        background-image: url("../assets/lottery/btn-submit.png");
        background-size: 100% 100%;
        cursor: pointer;
        position: absolute;
        bottom: -40px;

        &:active {
          bottom: -38px;
        }
      }

      a {
        text-decoration: none;
        outline: none;
        color: #00ffe6;
        font-size: 20px;
        margin-top: 40px;
      }
    }

    .cts {
      img {
        width: 50px;
        margin: 0 20px;
      }
    }
  }
}

.root {
  height: auto;
  padding-bottom: 30vh;
  background-image: url("../assets/lottery/bgi-h5.jpg");
  background-size: 100% 100%;
  display: flex;
  flex-flow: column;
  align-items: center;

  input::placeholder {
    color: #ffffff;
    font-size: 1em;
    font-style: normal;
    font-weight: normal;
  }

  .mid {
    width: 100%;
    padding: 5vw 0;

    img.logo {
      width: 30%;
    }

    .form {
      width: 90%;
      padding: 0 1.5vw 17vw;

      .form-input {
        margin-bottom: 1vw;

        input {
          height: 9vw;
          font-size: 1em;
        }
      }

      .btn {
        width: 70%;
        height: 20vw;
        line-height: 16vw;
        font-size: 1.5em;
        bottom: -8vw;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Lottery.vue